// eslint-disable-next-line
export default {
  id: 'panqueca_de_cottage',
  type: 'savoury',
  title: 'Panqueca de cottage',
  ingredients: ['120g de aveia', '120g de cottage', '2 ovos', 'Sal'],
  parts: [
    {
      title: 'Finalização',
      methodOfPreparation: [
        'Bate tudo no liquidificador até ficar líquido homogêneo',
        'Assa numa frigideira',
      ],
    },
  ],
};
